export const COMMITTEES_TRANSLATE = {
    committees: {
        breadcrumbName: "Comitês",
        messages: {
            create: "Comitê adicionado com sucesso",
            update: "Comitê atualizado com sucesso",
            delete: "Comitê deletado com sucesso",
            recover: "Comitê recuperado com sucesso"
        },
        list: {
            table: {
                columns: {
                    id: "ID",
                    name: "Nome"
                }
            },
            filters: {
                fields: {
                    id: {
                        label: "ID",
                        placeholder: "Informe o ID",
                        url: "id"
                    },
                    name: {
                        label: "Nome",
                        placeholder: "Informe o nome",
                        url: "nome"
                    },
                    active: {
                        label: "Situação",
                        placeholder: "Selecione a situação",
                        url: "situacao"
                    }
                }
            },
            dialog: {
                delete: {
                    title: "Inativar comitê",
                    body: "Tem certeza que deseja inativar o comitê com o ID {{id}}",
                    save: {
                        text: "Sim, inativar"
                    },
                    back: {
                        text: "Voltar"
                    },

                }
            }
        },
        save: {
            form: {
                fields: {
                    name: {
                        label: "Nome",
                        placeholder: "Informe o nome"

                    },
                    userIds: {
                        label: "Usuários",
                        placeholder: "Selecione os usuários"

                    },
                    categoryIds: {
                        label: "Categorias",
                        placeholder: "Selecione as categorias"

                    },
                }
            }
        },
        dictionaries: {
            breadcrumb: "Dicionários",
            messages: {
                create: "Dicionário criado com sucesso",
                update: "Dicionário atualizado com sucesso",
                delete: "Dicionário removido com sucesso",
                recover: "Dicionário recuperado com sucesso"
            },
            list: {
                table: {
                    columns: {
                        id: "ID",
                        language: "Idioma",
                        name: "Nome"
                    }
                },
                dialog: {
                    delete: {
                        title: "Remover dicionário",
                        body: "Tem certeza que deseja remover o dicionário com o ID {{id}}?",
                        save: {
                            text: "Sim, remover"
                        },
                        back: {
                            text: "Voltar"
                        }
                    }
                }
            },
            save: {
                form: {
                    fields: {
                        languageId: {
                            label: "Idioma",
                            placeholder: "Selecione o idioma"
                        },
                        name: {
                            label: "Nome",
                            placeholder: "Informe o nome"
                        }
                    }
                }
            }
        }
    }
}